module.exports = __webpack_public_path__ + "static/media/cap1-03-mob.78e63624.png";